import { TransientLayerState } from './transient-layer-state';

export type TabName = 'Static' | 'Dynamic';

export function isTabName(value: string): value is TabName {
  return value === 'Static' || value === 'Dynamic';
}

export class TransientShapeLayerState extends TransientLayerState {
  tagEditorActiveTab: TabName = 'Static';

  shapeListHidden = false;
  tagEditorHidden = true;
  shapeFiltersHidden = true;
}
